module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [_c('div', {
    class: ['pill', 'bold', 'py-3', 'px-4', 'text-center', _vm.pill.status]
  }, [_vm._v("\n        " + _vm._s(_vm.pill.message) + "\n    ")])])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-loader/node_modules/vue-hot-reload-api").rerender("data-v-a68b6006", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a68b6006"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/tools/Pill.vue
// module id = 1425
// module chunks = 0